"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReverseMortgageSecondIndividual = void 0;
var ReverseMortgageSecondIndividual;
(function (ReverseMortgageSecondIndividual) {
    ReverseMortgageSecondIndividual["NONE"] = "No";
    ReverseMortgageSecondIndividual["CO_BORROWER"] = "Co-Borrower";
    ReverseMortgageSecondIndividual["ELIGIBLE_NBS"] = "Eligible NBS";
    ReverseMortgageSecondIndividual["INELIGIBLE_NBS"] = "Ineligible NBS";
    ReverseMortgageSecondIndividual["OTHER"] = "Other Non-Borrower";
})(ReverseMortgageSecondIndividual = exports.ReverseMortgageSecondIndividual || (exports.ReverseMortgageSecondIndividual = {}));
